import { useMutation } from '@tanstack/react-query';
import apiClient from '../libs/apiClient';
import { AccessLink, AccessLinkParams } from '../types/accessLink';
import { ApiResponse } from '../types/response';

const createAccessLink = async (params: AccessLinkParams) => {
  const {
    data: { data },
  } = await apiClient.post<ApiResponse<AccessLink>>('/access-link', params);
  return data;
};

const useCreateAccessLink = () => {
  return useMutation({
    mutationFn: createAccessLink,
  });
};

export default useCreateAccessLink;
